import { MemberDatasource, IMemberDatasource } from './../../../global/datasources/member_datasource';
import { ILog } from './../../../global/types';
import { TransferConfiguration } from './../../config/transfer_configuration';
import { INewCourse } from './../pending_course_form_tile/pending_course_form_tile';
import { ITransferCollegeWithCourses } from './../../queries/transfer_colleges_with_courses_query';
import { CourseQueryResults } from './../../builders/course_query_results_builder';
import { Course } from './../../builders/course_builder';
import { ICommand } from 'core-ts-types';
import { ErrorsDict, IFormErrorService } from './../../../global/services/form_error_service/form_error_service';
import { IServerResponse } from './../../../global/interfaces/server_response';
import { IDisplayMessageService } from '../../../global/services/display_message_service';
import { getSearchResultsMessage } from '../../../global/strategies/search_results_strategy';

export class TransferCollegeTileController {
  querySet: {
    has_more: boolean;
    result: Course[];
  };

  flags: {
    isAddNewCourseTileShown: boolean;
    isAddNewCourseButtonEnabled: boolean;
  };

  model: {
    member: IMemberDatasource;
  };

  dropdownHeader = '';

  nonTransferableInstitutionText?: string;
  nonTransferableInstitutionLink?: boolean;

  private collegeWithCourses: ITransferCollegeWithCourses;
  private onClose: (item: Object) => void;

  private errors: ErrorsDict;

  constructor(
    private ngMemberDatasource: MemberDatasource,
    private ngTransferConfiguration: TransferConfiguration,
    private searchTransferCoursesCommand: ICommand,
    private selectTransferCourseCommand: ICommand,
    private addTransferMajorPendingCourseCommand: ICommand,
    private $timeout: ng.ITimeoutService,
    private $element: ng.IRootElementService,
    private log: ILog,
    private transferCourseTileDelegate: any,
    private formErrorService: IFormErrorService,
    private ngDisplayMessageService: IDisplayMessageService
  ) {
    const nonTransferableInstitutionMessage = this.ngDisplayMessageService('non_transferable_institution');
    this.nonTransferableInstitutionText =
      nonTransferableInstitutionMessage.text ||
      'We do not accept transfer courses from this institution because it does not meet our accreditation standards.';
    this.nonTransferableInstitutionLink = nonTransferableInstitutionMessage.add_contact_counselor_link;
  }

  $onInit() {
    this.model = {
      member: this.ngMemberDatasource.read()
    };

    this.flags = {
      isAddNewCourseButtonEnabled: false,
      isAddNewCourseTileShown: false
    };
  }

  onExitTab() {
    this.onClose({
      queryItem: this.collegeWithCourses.college
    });
  }

  onQueryChange($event: any): void {
    this.searchTransferCoursesCommand(this.collegeWithCourses.college.nk, $event.detail.value).then(
      (response: CourseQueryResults) => {
        this.querySet = {
          has_more: response.has_more,
          result: response.courses
        };

        this.dropdownHeader = getSearchResultsMessage(this.querySet);
      }
    );
  }

  onSelectCourse($event: any): void {
    // const courseNk = $event.detail.value;
    // const selectedCourseIndex = this.querySet.result.findIndex((_course: Course) => _course.nk === courseNk);
    const course: Course = $event.detail.item.__data.value;

    this.selectTransferCourseCommand(this.collegeWithCourses.college, course).then(() => {
      this.$timeout(() => {
        this.$element.find('hi-typeahead')[0]['searchValue'] = '';
        this.transferCourseTileDelegate.handle(course.id).strobe();
      });
    });
  }

  hasCourses() {
    return !_.isEmpty(this.collegeWithCourses.courses);
  }

  numCourses() {
    return _.size(this.collegeWithCourses.courses);
  }

  showAddNewCourseTile() {
    this.$element.find('hi-typeahead').removeAttr('opened');
    this.flags.isAddNewCourseTileShown = true;
    this.flags.isAddNewCourseButtonEnabled = true;
  }

  hideAddNewCourseTile() {
    this.flags.isAddNewCourseTileShown = false;
    this.errors = {};
  }

  addPendingCourse(newCourse: INewCourse) {
    this.flags.isAddNewCourseButtonEnabled = false;
    this.errors = {};
    return this.addTransferMajorPendingCourseCommand(this.collegeWithCourses.college, newCourse)
      .then((pendingCourse: Course) => {
        this.hideAddNewCourseTile();
        this.log.user.success({
          content: 'Your course has been added for review',
          timeout: 10000,
          dismissOnTimeout: true,
          dismissButton: true
        });
        this.$timeout(() => {
          this.transferCourseTileDelegate.handle(pendingCourse.id).strobe();
        });
      })
      .catch((response: ng.IHttpPromiseCallbackArg<IServerResponse>) => {
        this.flags.isAddNewCourseButtonEnabled = true;
        this.errors = this.formErrorService(response.data!.error);
      });
  }
}

angular
  .module('capability-ng-transfer')
  .controller('ngTransferCollegeTileController', TransferCollegeTileController)
  .component('transferCollegeTile', {
    controller: 'ngTransferCollegeTileController',
    templateUrl: 'lib/transfer/components/college_tile/college_tile.html',
    controllerAs: '$ctrl',
    bindings: {
      collegeWithCourses: '<',
      displayCourseAdditionalInfo: '<',
      onClose: '&'
    }
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/components/college_tile/college_tile.ts